import { render, staticRenderFns } from "./MyRouterLink.vue?vue&type=template&id=0a2b982e&scoped=true&"
import script from "./MyRouterLink.vue?vue&type=script&lang=js&"
export * from "./MyRouterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b982e",
  null
  
)

export default component.exports